module.exports = __webpack_public_path__ + "img/tt.9cde2b9e.svg";